import cx from 'classnames';
import { Services } from 'themes/playful/components/services/ServiceLIst';
import { TextureSection } from 'themes/playful/components/TextureSection/TextureSection';

import { useServicesPage } from 'hooks/page/services/useServicesPage';

import s1 from 'themes/playful/components/PlayfulLayout.module.css';
import s from 'themes/playful/components/services/Services.module.css';

export const PlayfulServices = () => {
  const {
    headingText,
    services,
    renderBookingHeader,
    renderSelectors,
    renderServiceProviderChangeModal,
    renderAutoBookingErrorModal,
    renderOfflineBookingModal,
    renderMaxAppointmentsWarning,
  } = useServicesPage();

  return (
    <>
      {renderBookingHeader()}
      <TextureSection title="Services">
        {headingText && services.length > 0 && (
          <section className={s1.content}>
            <div className={s.serviceFilter}>
              <h3 className={cx(s.filterTitle)}>{headingText}</h3>
              <div className={s.filterWrapper}>{renderSelectors()}</div>
            </div>
          </section>
        )}
        <Services />
      </TextureSection>
      {renderAutoBookingErrorModal()}
      {renderOfflineBookingModal()}
      {renderServiceProviderChangeModal()}
      {renderMaxAppointmentsWarning()}
    </>
  );
};
